import { useSelfAssessmentWizardQuestionForm } from './SelfAssessmentWizardQuestion.hooks'
import { SelfAssessmentWizardQuestionUI } from './SelfAssessmentWizardQuestion.ui'

export const SelfAssessmentWizardQuestion = () => {
  const { question, questionIndex } = useSelfAssessmentWizardQuestionForm()

  return <SelfAssessmentWizardQuestionUI question={question} questionIndex={questionIndex} />
}
